module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-32.7499d72f.png";